module.exports = __webpack_public_path__ + "static/media/number-one.aae2f681.svg";